import { ForgotPasswordForm } from '../../components/auth/forgot-password-form'

export default function ForgotPassword() {
  return <ForgotPasswordForm />
}

